import React from 'react';
import get from 'lodash/get';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { StandaloneCheckbox } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isChecked } from '../../../utils/validation';

const SwitchDateTermsSwitch = ({ values }) => (
  <Content>
    {({ switchDateTerms1Label = '', switchDateTerms1ValidationMessage = '' }) => (
      <Field
        name="switchDateSwitch"
        subscription={{ touched: true, error: true }}
        validate={isChecked}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="switchDateSwitch"
            validationMessage={touched && !!error ? switchDateTerms1ValidationMessage : ''}
          >
            <StandaloneCheckbox
              isChecked={get(values, 'switchDateSwitch.isChecked', false)}
              id="switchDateSwitch"
              labelText={switchDateTerms1Label}
              onChange={({ isChecked }) => {
                input.onChange(isChecked);
              }}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default SwitchDateTermsSwitch;
